<bl-modal-content #content
  [title]="'受付状況の変更'"
  [footerButtonType]="footerButtonType"
  [okButtonSetting]="okButtonSetting"
>
  <div body>
    <div class="content">
      <span class="content-title">受付状況</span>
      <div class="content-item">
        <div class="radio-group">
          <bl-radio-group
            [items]="bizNegoStatusItems"
            [value]="editData.bizNegoStatus"
            [option]="{ labelProperty: 'name', valueProperty: 'code' }"
            [groupType]="'inline'"
            [validator]="blFormGroup?.validatorGroup['BizNegoInfo#bizNegoStatus']"
            (changeEvent)="onChangeBizNegoStatus($event)"
            >
          </bl-radio-group>
        </div>
      </div>
    </div>
    <div class="content">
      <span class="content-title">キャンセル日</span>
      <div class="date-select">
        <bl-date
          [(value)]="editData.cancelDate"
          [disabled]="editData.bizNegoStatus !== BizNegoStatus.Cancel || currentMode !== ModalMode.Change"
          [validator]="blFormGroup?.validatorGroup['BizNegoInfo#cancelDate']"
        ></bl-date>
      </div>
    </div>
    <div class="content">
      <span class="content-title">キャンセル理由</span>
      <div class="select">
        <bl-select
          placeholder="キャンセル理由を選択してください。"
          [(value)]="editData.cancelReasonAnalysisItemCode"
          [items]="cancelReasonList"
          [readonly]="editData?.bizNegoStatus !== BizNegoStatus.Cancel || cancelReasonList.length === 0"
          [validator]="blFormGroup?.validatorGroup['BizNegoInfo#cancelReasonAnalysisItemCode']"
          [disabled]="editData.bizNegoStatus !== BizNegoStatus.Cancel || currentMode !== ModalMode.Change"
        ></bl-select>
      </div>
      <div class="textarea">
        <bl-textarea
          placeholder="その他の理由を入力してください。"
          [rows]="4"
          [(value)]="editData.cancelReason"
          [validator]="blFormGroup?.validatorGroup['BizNegoInfo#cancelReason']"
          [disabled]="editData.bizNegoStatus !== BizNegoStatus.Cancel || currentMode !== ModalMode.Change"
        ></bl-textarea>
      </div>
    </div>


  </div>
</bl-modal-content>



// WEBPACK FOOTER //
// ./src/app/page/recept-list-page/modal/recept-state-modal/recept-state-modal.component.html